var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlayIcon_svg__clip0_5958_1591)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 7c0-3.865 3.135-7 7-7s7 3.135 7 7-3.135 7-7 7-7-3.135-7-7zM7 .875A6.127 6.127 0 00.875 7 6.127 6.127 0 007 13.125 6.127 6.127 0 0013.125 7 6.127 6.127 0 007 .875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.534 9.827l4.159-2.492A.394.394 0 009.883 7a.39.39 0 00-.19-.335L5.534 4.173a.394.394 0 00-.54.14.386.386 0 00-.053.195v4.984a.386.386 0 00.198.34.394.394 0 00.395-.005z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PlayIcon_svg__clip0_5958_1591"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgPlayIcon;